import AddToCartBase from "./add_to_cart_base";

export default class AddToCart extends AddToCartBase {}
